module.exports = __webpack_public_path__ + "static/media/66800009-44F0wSgs.9a14d71b.JPG";